module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/washubar-1c5fde751813c981c5ddbdba00a77460.jpg";